import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const CirclePlusIconSvg = () => (
  <svg width="2.75em" height="2.75em" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="18.5" r="17.5" fill="white" stroke="#00000"/>
    <path d="M18.5 10.542V27.4587" stroke="#5C6172" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.0417 19H26.9584" stroke="#5C6172" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const CirclePlusIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CirclePlusIconSvg} {...props} />
);